/**
 * Impersonation State Singleton
 *
 * Provides a way for AuthContext to share impersonation state
 * with axios interceptors (which don't have access to React context).
 *
 * Usage:
 * - AuthContext calls impersonationState.set() when impersonation starts/ends
 * - Axios interceptors call impersonationState.get() to add headers
 */

class ImpersonationState {
  constructor() {
    this.state = null;
  }

  set(impersonation) {
    this.state = impersonation && impersonation.isImpersonating ? impersonation : null;
  }

  get() {
    return this.state;
  }

  isImpersonating() {
    return this.state && this.state.isImpersonating === true;
  }
}

// Export singleton instance
export const impersonationState = new ImpersonationState();
